import { useEffect, useState } from "react";
import { domain, token } from "../../../Security";
import axios from "../../../../api/apiClient";

export function TimeDevice({ device, setDevice }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setDevice(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Device";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (device !== "" && device !== 0 && device !== null && device !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [device]);

  return (
    <div>
      <select id="" className="filterSelect" value={device} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose a device</option>
        {data.map((device) => (
          SetTimeDevice(device)
        ))}
      </select>
    </div>
  );
};

function SetTimeDevice(device) {
  return (
    <option value={device.name}>{
      device.name}
    </option>
  )
}